import React from "react";
import { useParams } from "react-router-dom";
import Header from "../components/element/header-section/HeaderSection";
import t from "../helpers/t9n";
import Orders from "./Orders/Orders";

const OrdersPage = () => {
  let { lang } = useParams();
  
  return (
    <>
      <Header heading={t("global.order.view")} hasImage={true} isRed={true} />
      <Orders lang={lang} />
    </>
  )
}

export default OrdersPage;
